'use strict';

// DEV-17982: presentation for the additionalinfo abuse cards rendered under a
// phone-abuse flagged Title or Description. One instance per flagged field
// (additionalinfo_abuse_title / additionalinfo_abuse_description). Owns the
// card visibility, the mirror<->canonical input sync and the http:// prefill.
// The check state machine lives in mobile/modules/paf_phone_abuse_check.js and
// drives this module through set_visible() and backfill_canonical() only.

export class Additionalinfo {
	static bindings_done = false;

	constructor(component_key) {
		this.id = component_key;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
	}

	get field() {
		return this.$root.data('abuse-field');
	}

	init() {
		if (!this.$root.hasClass('js-additionalinfo-abuse')) {
			return; // paf/confirm usages never activate JS; defensive
		}
		Additionalinfo.bind_global();
	}

	set_visible(visible) {
		if (visible) {
			yalwa.basics.show(this.$root);
		} else {
			yalwa.basics.hide(this.$root);
		}
		Additionalinfo.toggle_transcriber(this.field, !visible);
	}

	// the voice recording feature must not compete with the abuse card for the
	// same field: while the card asks the user to fix that text the recorder is
	// hidden, and it comes back as soon as the card is gone. Hiding it while a
	// dictation runs also stops it — the transcriber observes its own visibility.
	static toggle_transcriber(field, visible) {
		const transcriber = (yalwa.v.component_instances || {})['transcriber_' + field];
		if (!transcriber || !transcriber.$root || !transcriber.$root.length) {
			return;
		}
		if (visible) {
			yalwa.basics.show(transcriber.$root);
		} else {
			yalwa.basics.hide(transcriber.$root);
		}
	}

	backfill_canonical() {
		Additionalinfo.backfill_canonical();
	}

	static bind_global() {
		if (Additionalinfo.bindings_done) {
			return;
		}
		Additionalinfo.bindings_done = true;
		jQuery(document).on('input', '.js-mpaf_title_input, .js-mpaf_description_textarea, input[name="text_features.phone_number"], input[name="text_features.url"], input[name^="abuse_phone_"], input[name^="abuse_website_"]', function() {
			Additionalinfo.sync_from_target(jQuery(this));
		});
		// same http:// prefill the canonical website input has (paf.js features
		// init): focus on empty fills it, blur strips it when nothing was typed
		jQuery(document).on('focus', 'input[name^="abuse_website_"]', function() {
			if (!jQuery(this).val()) {
				jQuery(this).val('http://');
			}
		}).on('blur', 'input[name^="abuse_website_"]', function() {
			if (jQuery(this).val() === 'http://') {
				jQuery(this).val('');
				Additionalinfo.sync_from_target(jQuery(this));
			}
		});
	}

	static sync_from_target($target) {
		const is_abuse_phone = $target.is('[name^="abuse_phone_"]');
		const is_abuse_website = $target.is('[name^="abuse_website_"]');
		const is_canonical_phone = $target.is('[name="text_features.phone_number"]');
		const is_canonical_website = $target.is('[name="text_features.url"]');
		if (!is_abuse_phone && !is_abuse_website && !is_canonical_phone && !is_canonical_website) {
			return;
		}
		const value = $target.val() || '';
		let prefix;
		if (is_abuse_phone || is_abuse_website) {
			// mirrors write through into the canonical submission input
			prefix = is_abuse_phone ? 'abuse_phone_' : 'abuse_website_';
			const $canonical = jQuery(is_abuse_phone ? 'input[name="text_features.phone_number"]' : 'input[name="text_features.url"]').first();
			if ($canonical.length) {
				// the submit payload is built from the lc state, which the features
				// section only updates on change (paf.js init_feature_inputs)
				$canonical.val(value).trigger('input').trigger('change');
			}
		} else {
			prefix = is_canonical_phone ? 'abuse_phone_' : 'abuse_website_';
		}
		jQuery(`input[name^="${prefix}"]`).each(function() {
			if (this !== $target[0] && this !== document.activeElement) {
				jQuery(this).val(value);
			}
		});
	}

	// The canonical text_features inputs are created only when the selected
	// category renders them — a value typed into an abuse mirror earlier
	// would otherwise be lost at the final submit. Runs on every check/guard
	// pass: pushes mirror values into empty canonical inputs and backfills
	// mirrors from a canonical the user typed into directly.
	static backfill_canonical() {
		[
			['abuse_phone_', 'input[name="text_features.phone_number"]'],
			['abuse_website_', 'input[name="text_features.url"]']
		].forEach(([prefix, canonical_selector]) => {
			const $canonical = jQuery(canonical_selector).first();
			if (!$canonical.length) {
				return;
			}
			const canonical_value = $canonical.val() || '';
			const $mirrors = jQuery(`input[name^="${prefix}"]`);
			if (!canonical_value) {
				const mirror_value = $mirrors.map(function() { return jQuery(this).val() || ''; }).get().find((value) => value !== '') || '';
				if (mirror_value) {
					$canonical.val(mirror_value).trigger('input').trigger('change');
				}
				return;
			}
			$mirrors.each(function() {
				if (this !== document.activeElement && !jQuery(this).val()) {
					jQuery(this).val(canonical_value);
				}
			});
		});
	}
}
